<template>
  <RouterLink
    :class="[
      'testv__post__item__wrapper',
      `testv__post__item__wrapper--${type}`
    ]"
    event=""
    :to="{ name: 'Post', query: { id: post.id, type: type } }"
    @click.native="onRoute">
    <TestvPostDate
      class="testv__post__item__side"
      :date="post.released_at"
      :category="post.title_prefix"
    />
    <div class="testv__post__item__right">
      <div class="testv__post__item">
        <div class="testv__post__item__title">{{ post.title }}</div>
        <div class="testv__post__item__banner__wrapper">
          <img :src="banner"/>
          <SsButton2 v-if="play" class="testv__post__item__btn__play">
            <IconPlay class="testv__post__item__icon__play"/>
          </SsButton2>
        </div>
        <div class="testv__post__item__count">
          <IconComment class="icon__comment"/>
          <span>{{ post.comment_count }} 位铁丝参与讨论</span>
        </div>
      </div>
    </div>
  </RouterLink>
</template>

<script>
import TestvPostDate from '@/components/TestvPostDate/index.vue'
import { formatImageByImageMogr2, formatDate } from '@/utils/index.js'

export default {
  name: 'TestvPostItem',

  components: {
    TestvPostDate
  },

  props: {
    post: {
      type: Object,
      require: true
    }
  },

  computed: {
    type () {
      switch (this.post.post_type) {
        case 2:
          return 'video'
        case 4:
          return 'podcast'
        default:
          return 'normal'
      }
    },
    play () {
      return [2, 4].includes(this.post.post_type)
    },
    banner () {
      const banner = this.post.banner || 'https://cdn-static.sspai.com/page/testv/assets/placeholder.jpeg'
      if (this.type === 'normal') {
        return this.formatImageByImageMogr2(banner, { mode: 'crop', w: 1420, h: 708 })
      }
      return this.formatImageByImageMogr2(banner, {})
    }
  },

  methods: {
    formatImageByImageMogr2,
    formatDate,
    onRoute () {
      // console.log('TestvPostItem: ', 'push')
      this.$store.commit('setAction', 'push')
      this.$router.push({ name: 'Post', query: { id: this.post.id, type: this.type } })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import "~@/assets/styles/variable.styl"
.testv__post__item__wrapper {
  display: flex;
  justify-content: space-between;
  column-gap: 20px;
  @media (any-hover: hover) {
    &:hover {
      --color-TestvPostItemSide: var(--dark-bwb-5);
      --color-TestvPostItemTitle: var(--yellow-testv);
    }
  }
  @media (min-width: $screen-md) {
    column-gap: 35px;
  }
  @media (min-width: $screen-default) {
    column-gap: 108px;
  }
}

.testv__post__item__right {
  flex: 1;
  max-width: 600px;
  position: relative;
  &::after {
    content: '';
    display: block;
    background-image: url("~@/assets/images/border.png")
    background-size: auto 100%;
    width: 100%;
    height: 2px;
    position: absolute;
    left: 0;
    bottom: 0;
  }
  padding-bottom: 40px;
  @media (min-width: $screen-md) {
    padding-bottom: 56px;
  }
}

.testv__post__item {
  max-width: 600px;
}

.testv__post__item__side {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  color: var(--color-TestvPostItemSide, var(--dark-bwb-3));
  transition: .2s;
  row-gap: 8px;
  --size-TestvPostDateText: 32px;
  --size-TestvPostDateText--md: 72px;
  --size-TestvPostDateText--max: 72px;
  --size-TestvPostDateIcon: 32px;
  --size-TestvPostDateIcon--md: 72px;
  --size-TestvPostDateIcon--max: 72px;
  @media (min-width: $screen-md) {
    row-gap: 16px;
  }
}

.testv__post__item__title {
  font-size: 20px;
  font-weight: 500;
  color: var(--color-TestvPostItemTitle, var(--dark-bwb-8))
  transition: .2s;
  @media (min-width: $screen-md) {
    font-size: 32px;
    font-weight: 600;
  }
}

.testv__post__item__banner__wrapper {
  position: relative;
  display: inline-block;
  margin: 16px 0px;
  img {
    max-height: 440px;
    object-fit: contain;
    object-position: left;
  }
  .testv__post__item__btn__play {
    position: absolute;
    bottom: 16px;
    right: 16px;
    width: 64px;
    height: 64px;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--yellow-testv);
    .testv__post__item__icon__play {
      width: 32px;
      height: 32px;
      color: var(--dark-bwb-0);
    }
  }
  @media (min-width: $screen-md) {
    margin: 24px 0px;
    img {
      max-height: 600px;
    }
  }
}

.testv__post__item__wrapper--podcast {
  @media (min-width: $screen-md) {
    .testv__post__item__banner__wrapper {
      img {
        max-width: 520px;
      }
    }
  }
}

.testv__post__item__count {
  display: flex;
  align-items: center;
  column-gap: 4px;
  font-size: 13px;
  color: var(--color-TestvPostItemComent, var(--dark-bwb-6))
  .icon__comment {
    width: 20px;
    height: 20px;
  }
  @media (min-width: $screen-md) {
    font-size: 15px;
    column-gap: 8px;
    .icon__comment {
      width: 24px;
      height: 24px;
    }
  }
}
</style>
